import { Component, OnInit, AfterViewInit, Inject } from '@angular/core';
import { ItemPedido } from 'src/app/models/pedido';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { BehaviorSubject, Subject } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfiguracaoFamiliaOrcamento, ConfiguracaoFamiliaOrcamentoItem } from 'src/app/models/configuracao-familia-orcamento';
import { CarregandoService } from 'src/app/services/carregando.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import swal from 'sweetalert2';
import { GlobalService } from 'src/app/services/global.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { PrecificacaoUF } from 'src/app/models/precificacao-uf';
import { FormControl } from "@angular/forms";
import { ConfiguracaoCategoriaOrcamento } from "../../models/configuracao-categoria-orcamento";
import { CategoriaService } from "../../services/categoria.service";
import { Categoria } from "../../models/categoria";
import { Cliente } from "../../models/cliente";
import { TipoFiltroProduto } from "../../models/enum";

declare const $: any;

@Component({
  selector: 'app-produtos-modal',
  templateUrl: './produtos-modal.component.html',
  styleUrls: ['./produtos-modal.component.scss']
})
export class ProdutosModalComponent implements OnInit, AfterViewInit {

  // variáveis
  kits: ItemPedido[] = [];
  paineis: ItemPedido[] = [];
  inversores: ItemPedido[] = [];
  stringboxes: ItemPedido[] = [];
  cabos: ItemPedido[] = [];
  estruturas: ItemPedido[] = [];
  outros: ItemPedido[] = [];
  transformadores: ItemPedido[] = [];
  baterias: ItemPedido[] = [];
  produtos: ItemPedido[] = [];
  public config: PerfectScrollbarConfigInterface = {};
  producaoPorPainel;
  quantidadeDePaineis;
  potenciaPainel;
  potTotal;
  fornecedores: number[] = [];

  usaFornecedor = false;
  potenciaParaFiltrar = 0;
  potenciaParaFiltrarPainel = 0;

  configuracaoFamiliaOrcamento: ConfiguracaoFamiliaOrcamento;
  configuracaoCategoriaOrcamento: ConfiguracaoCategoriaOrcamento = new ConfiguracaoCategoriaOrcamento();

  mostrarCabecalho = false;
  situacao = 'A';

  msgAlterarCD;

  familia = 2;
  categoria = 2;

  somenteKit = false;
  semKit = false;
  semPainel = false;
  semInversor = false;
  mostrarValores = false;
  integrador = false;
  origem: number;
  idFornecedorPainel: number;

  liberado = false;

  somenteEstrutura = false;

  //Esta flag diz respeito a selecionar apenas um produto por família
  selecionaSomenteUm = false;
  naoMostrarValores = false;

  descAcresPrecificacaoUF: PrecificacaoUF;

  mostrarSomenteFamiliaEspecifica: number = null;

  //Esta flag diz respeito a selecionar apenas um produto independente da família
  selecionaSomenteUmProduto: boolean = false;
  backup = null;
  backupSelected = null;
  selected = new FormControl(0);

  produtosLoja: ItemPedido[] = [];
  idLoja: number;
  cliente: Cliente;

  // Todas as famílias disponíveis (fonte única de dados)
  TODAS_FAMILIAS: Familia[] = [
    { idFamilia: '1', descricao: 'Outro', ordem: 8, visivel: true, icone: 'fas fa-box' },
    { idFamilia: '2', descricao: 'Painel', ordem: 1, visivel: true, icone: 'fas fa-solar-panel' },
    { idFamilia: '3', descricao: 'Inversor', ordem: 2, visivel: true, icone: 'fas fa-tablet' },
    { idFamilia: '4', descricao: 'Stringbox', ordem: 0, visivel: true, icone: 'fas fa-server' },
    { idFamilia: '5', descricao: 'Cabo', ordem: 0, visivel: true, icone: 'fas fa-plug' },
    { idFamilia: '6', descricao: 'Estrutura', ordem: 0, visivel: true, icone: 'fas fa-layer-group' },
    { idFamilia: '7', descricao: 'Kit', ordem: 0, visivel: true, icone: 'far fa-list-alt' },
    { idFamilia: '8', descricao: 'Transformador', ordem: 6, visivel: true, icone: 'fas fa-bolt' },
    { idFamilia: '9', descricao: 'Bateria', ordem: 7, visivel: true, icone: 'fa fa-battery-full' },
  ];
  somenteMSK: boolean = false;

  validaOrigem: boolean = true;

  public alterouAbaSubject: BehaviorSubject<any> = new BehaviorSubject<any>({});

  constructor(public dialogRef: MatDialogRef<ProdutosModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private premissasService: PremissasService,
    private categoriaService: CategoriaService
  ) {
    this.somenteKit = data.somenteKit;
    this.semKit = data.semKit;
    this.semPainel = data.semPainel;
    this.semInversor = data.semInversor;
    this.produtos = data.produtos;
    this.producaoPorPainel = data.producaoPorPainel;
    this.quantidadeDePaineis = data.quantidadeDePaineis;
    this.potenciaPainel = data.potenciaPainel;
    this.potTotal = data.potTotal;

    this.potenciaParaFiltrar = Number(data.potTotal) * 1000;
    this.potenciaParaFiltrarPainel = Number(data.potenciaPainel);
    this.origem = Number(data.origem);

    if (Number.isNaN(this.origem) || this.origem == null) {
      this.validaOrigem = false;
    }

    this.msgAlterarCD = data.msgAlterarCD;
    this.naoMostrarValores = data.naoMostrarValores;
    this.descAcresPrecificacaoUF = data.descAcresPrecificacaoUF;
    this.mostrarSomenteFamiliaEspecifica = data.mostrarSomenteFamiliaEspecifica;
    this.somenteMSK = data.somenteMSK;

    if (data.situacao === 'T') {
      this.situacao = '';
    }

    this.somenteEstrutura = data.somenteEstrutura;
    this.selecionaSomenteUm = data.selecionaSomenteUm;
    this.idFornecedorPainel = data.idFornecedorPainel;

    this.montarConfiguracaoFamilia();

    this.mostrarCabecalho = data.mostrarCabecalho;

    this.liberado = true;

    this.selecionaSomenteUmProduto = data.selecionaSomenteUmProduto;

    this.idLoja = data.idLoja;
    this.cliente = data.cliente;
  }

  ngAfterContentInit(): void {

  }

  obterFamilia(id: number): Familia | undefined {
    return this.TODAS_FAMILIAS.find(f => f.idFamilia === id.toString());
  }

  montarConfiguracaoFamilia(): void {
    if (this.mostrarSomenteFamiliaEspecifica != null) {
      const familia = this.obterFamilia(this.mostrarSomenteFamiliaEspecifica);

      if (familia) {
        this.configuracaoFamiliaOrcamento = { familias: [familia] };
      }
      return;
    }

    // Caso contrário, monta dinamicamente
    let familiasSelecionadas: Familia[] = [];

    if (this.somenteKit) {
      familiasSelecionadas = [this.obterFamilia(7)!];
    }
    else if (this.semKit) {
      if (this.semPainel && this.semInversor) {
        familiasSelecionadas = [
          this.obterFamilia(5)!,
          this.obterFamilia(4)!,
          this.obterFamilia(6)!,
          this.obterFamilia(8)!,
          this.obterFamilia(9)!,
          this.obterFamilia(1)!,
        ];
      } else {
        familiasSelecionadas = [
          this.obterFamilia(2)!,
          this.obterFamilia(3)!,
          this.obterFamilia(5)!,
          this.obterFamilia(4)!,
          this.obterFamilia(6)!,
          this.obterFamilia(8)!,
          this.obterFamilia(9)!,
          this.obterFamilia(1)!,
        ];
      }
    }
    else if (this.somenteEstrutura) {
      familiasSelecionadas = [this.obterFamilia(6)!];
    }
    else {
      familiasSelecionadas = [
        this.obterFamilia(7)!,
        this.obterFamilia(2)!,
        this.obterFamilia(3)!,
        this.obterFamilia(5)!,
        this.obterFamilia(4)!,
        this.obterFamilia(6)!,
        this.obterFamilia(8)!,
        this.obterFamilia(9)!,
        this.obterFamilia(1)!,
      ];
    }

    // Define o resultado final
    this.configuracaoFamiliaOrcamento = { familias: familiasSelecionadas };
  }

  ativaAba(fam) {
    this.familia = fam;
    this.alterouAbaSubject.next({ familia: this.familia === 10 ? 1 : this.familia, fornecedores: this.fornecedores });
  }

  proximo() {
    this.familia++;
    this.alterouAbaSubject.next({ familia: this.familia === 10 ? 1 : this.familia, fornecedores: this.fornecedores });
  }

  anterior() {
    this.familia--;
    this.alterouAbaSubject.next({ familia: this.familia === 10 ? 1 : this.familia, fornecedores: this.fornecedores });
  }

  // atualiza as listas de produtos dependendo do tipo
  atualizaLista(lista: ItemPedido[], tipo: number) {

    tipo = Number(tipo);

    switch (tipo) {
      case 1:
        this.outros = lista;
        break;
      case 2:
      case 7:
        this.carregandoService.mostra('TrocouFornecedor');

        if (tipo === 2) {
          this.paineis = lista;
        } else {
          this.kits = lista;
        }

        this.carregandoService.esconde('TrocouFornecedor');

        break;
      case 3:
        this.inversores = lista;
        break;
      case 4:
        this.stringboxes = lista;
        break;
      case 5:
        this.cabos = lista;
        break;
      case 6:
        this.estruturas = lista;
        break;

      case 8:
        this.transformadores = lista;
        break;

      case 9:
        this.baterias = lista;
        break;

      default:
        break;
    }

    if (this.selecionaSomenteUmProduto) {
      const algumProdutoChecado = lista.some(p => p.checado);

      if (algumProdutoChecado) {
        if (!this.backup) {
          this.backup = JSON.stringify(this.configuracaoFamiliaOrcamento.familias);
          this.backupSelected = this.selected.value;
        }

        this.configuracaoFamiliaOrcamento.familias = this.configuracaoFamiliaOrcamento.familias
          .map(f => ({ ...f, visivel: f.idFamilia === tipo.toString() }))
          .filter(f => f.visivel);
      } else if (this.backup) {
        this.configuracaoFamiliaOrcamento.familias = JSON.parse(this.backup);

        setTimeout(() => {
          this.selected.setValue(this.backupSelected);
        });

        this.backup = null;
        this.backupSelected = null;
      }
    }
  }

  // retorna os produtos para quem chamou a tela
  retornaProdutos() {
    // concatena todas as listas e retorna
    this.dialogRef.close(this.outros.concat(this.paineis).concat(this.inversores).concat(this.stringboxes)
      .concat(this.cabos).concat(this.estruturas).concat(this.kits).concat(this.transformadores).concat(this.baterias));
  }

  // verifica se alguma lista possui não está vazia
  validar() {
    return this.outros.length > 0 ||
      this.kits.length > 0 ||
      this.paineis.length > 0 ||
      this.inversores.length > 0 ||
      this.stringboxes.length > 0 ||
      this.cabos.length > 0 ||
      this.estruturas.length > 0 ||
      this.transformadores.length > 0 ||
      this.baterias.length > 0;
  }

  async ngOnInit() {
    this.integrador = await this.globalService.integrador();
    this.buscarVerPrecosProdutos();

    // verifica configuração da empresa
    // this.buscarCategorias();

    this.configuracaoFamiliaOrcamento.familias = this.configuracaoFamiliaOrcamento.familias.filter(f => f.visivel);
    // this.configuracaoCategoriaOrcamento.categorias = this.configuracaoCategoriaOrcamento.categorias.filter(c => c.visivel);

    // filtra os produtos de acordo com o tipo
    this.kits = this.produtos.filter(p => p.produtoTela.familia === 7);
    this.paineis = this.produtos.filter(p => p.produtoTela.familia === 2);
    this.inversores = this.produtos.filter(p => p.produtoTela.familia === 3);
    this.stringboxes = this.produtos.filter(p => p.produtoTela.familia === 4);
    this.cabos = this.produtos.filter(p => p.produtoTela.familia === 5);
    this.estruturas = this.produtos.filter(p => p.produtoTela.familia === 6);
    this.outros = this.produtos.filter(p => p.produtoTela.familia === 1);
    this.transformadores = this.produtos.filter(p => p.produtoTela.familia === 8);
    this.baterias = this.produtos.filter(p => p.produtoTela.familia === 9);
    this.familia = Number(this.configuracaoFamiliaOrcamento.familias[0].idFamilia);
    // setTimeout(() => {
    //   this.alterouAbaSubject.next({ familia: this.familia, fornecedores: this.fornecedores });
    // }, 3000);

    this.alterouAbaSubject.next({ familia: this.familia, fornecedores: this.fornecedores });
  }

  buscarCategorias() {
    this.carregandoService.mostra('buscaCategorias');
    this.categoriaService.listar().subscribe(data => {
      this.configuracaoCategoriaOrcamento.categorias = data;

      if (this.configuracaoCategoriaOrcamento.categorias.length !== 0) {
        this.configuracaoCategoriaOrcamento.categorias.forEach(c => { c.visivel = true});
      }

      this.carregandoService.esconde('buscaCategorias');
      }, (erro) => {
      this.carregandoService.esconde('buscaCategorias');
      this.notificacaoService.erro(erro);
    });
  }

  retornarProdutosPorFamilia(familia: string) {
    switch (familia) {
    case '7':
      return this.kits;
      break;
    case '6':
      return this.estruturas;
      break;
    case '5':
      return this.cabos;
      break;
    case '4':
      return this.stringboxes;
      break;
    case '3':
      return this.inversores;
      break;
    case '2':
      return this.paineis;
      break;
    case '1':
      return this.outros;
      break;
    case '8':
      return this.transformadores;
      break;
    case '9':
      return this.baterias;
      break;

    }

  }

  ngAfterViewInit() {


    const elemMainPanel = <HTMLElement>document.querySelector('.mat-dialog-container');

    // if (!$('.wizard-produtos .tab-content').find('.active').length) {
    //   alert('opa');
    //   $('.wizard-produtos').find('.tab-pane:first-child').addClass('active');

    // }

    // // Wizard Initialization
    // $('.wizard-produtos').bootstrapWizard({
    //   'tabClass': 'nav nav-pills',
    //   'nextSelector': '.btn-next',
    //   'previousSelector': '.btn-previous',

    //   onNext: function (tab, navigation, index) {


    //   },

    //   onInit: function (tab: any, navigation: any, index: any) {


    //     // check number of tabs and fill the entire row
    //     let $total = navigation.find('li').length;

    //     let $wizard = navigation.closest('.wizard-produtos');

    //     let $first_li = navigation.find('li:first-child a').html();
    //     let $moving_div = $('<div class="moving-tab">' + $first_li + '</div>');
    //     $('.wizard-produtos .wizard-navigation').append($moving_div);

    //     $total = $wizard.find('.nav li').length;
    //     let $li_width = 100 / $total;

    //     let total_steps = $wizard.find('.nav li').length;
    //     let move_distance = $wizard.width() / total_steps;
    //     let index_temp = index;
    //     let vertical_level = 0;

    //     let mobile_device = $(document).width() < 600 && $total > 3;

    //     if (mobile_device) {
    //       move_distance = $wizard.width() / 2;
    //       index_temp = index % 2;
    //       $li_width = 50;
    //     }

    //     $wizard.find('.nav li').css('width', $li_width + '%');

    //     let step_width = move_distance;
    //     move_distance = move_distance * index_temp;

    //     let $current = index + 1;

    //     if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
    //       move_distance -= 8;
    //     } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
    //       move_distance += 8;
    //     }

    //     if (mobile_device) {
    //       let x: any = index / 2;
    //       vertical_level = parseInt(x);
    //       vertical_level = vertical_level * 38;
    //     }

    //     $wizard.find('.moving-tab').css('width', step_width);
    //     $('.wizard-produtos .moving-tab').css({
    //       'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
    //       'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

    //     });
    //     $('.wizard-produtos .moving-tab').css('transition', 'transform 0s');
    //   },

    //   onTabClick: function (tab: any, navigation: any, index: any) {
    //     return true;
    //   },

    //   onTabShow: function (tab: any, navigation: any, index: any) {



    //     let $total = navigation.find('li').length;
    //     let $current = index + 1;
    //     elemMainPanel.scrollTop = 0;
    //     const $wizard = navigation.closest('.wizard-produtos');

    //     // If it's the last tab then hide the last button and show the finish instead
    //     if ($current >= $total) {
    //       $($wizard).find('.btn-next').hide();
    //       $($wizard).find('.btn-finish').show();
    //     } else {
    //       $($wizard).find('.btn-next').show();
    //       $($wizard).find('.btn-finish').hide();
    //     }

    //     const button_text = navigation.find('li:nth-child(' + $current + ') a').html();

    //     setTimeout(function () {
    //       $('.wizard-produtos .moving-tab').text(button_text);
    //     }, 150);

    //     const checkbox = $('.footer-checkbox');

    //     if (index !== 0) {
    //       $(checkbox).css({
    //         'opacity': '0',
    //         'visibility': 'hidden',
    //         'position': 'absolute'
    //       });
    //     } else {
    //       $(checkbox).css({
    //         'opacity': '1',
    //         'visibility': 'visible'
    //       });
    //     }
    //     $total = $wizard.find('.nav li').length;
    //     let $li_width = 100 / $total;

    //     let total_steps = $wizard.find('.nav li').length;
    //     let move_distance = $wizard.width() / total_steps;
    //     let index_temp = index;
    //     let vertical_level = 0;

    //     let mobile_device = $(document).width() < 600 && $total > 3;

    //     if (mobile_device) {
    //       move_distance = $wizard.width() / 2;
    //       index_temp = index % 2;
    //       $li_width = 50;
    //     }

    //     $wizard.find('.nav li').css('width', $li_width + '%');

    //     let step_width = move_distance;
    //     move_distance = move_distance * index_temp;

    //     $current = index + 1;

    //     if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
    //       move_distance -= 8;
    //     } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
    //       move_distance += 8;
    //     }

    //     if (mobile_device) {
    //       let x: any = index / 2;
    //       vertical_level = parseInt(x);
    //       vertical_level = vertical_level * 38;
    //     }

    //     $wizard.find('.moving-tab').css('width', step_width);
    //     $wizard.find('.moving-tab').css({
    //       'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
    //       'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'

    //     });
    // }
    // });


    // Prepare the preview for profile picture
    $('#wizard-picture').change(function () {
      const input = $(this);

      if (input[0].files && input[0].files[0]) {
        const reader = new FileReader();

        reader.onload = function (e: any) {
          $('#wizardPicturePreview').attr('src', e.target.result).fadeIn('slow');
        };
        reader.readAsDataURL(input[0].files[0]);
      }
    });

    $('[data-toggle="wizard-radio"]').click(function () {
      const wizard = $(this).closest('.wizard-produtos');
      wizard.find('[data-toggle="wizard-radio"]').removeClass('active');
      $(this).addClass('active');
      $(wizard).find('[type="radio"]').removeAttr('checked');
      $(this).find('[type="radio"]').attr('checked', 'true');
    });

    $('[data-toggle="wizard-checkbox"]').click(function () {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).find('[type="checkbox"]').removeAttr('checked');
      } else {
        $(this).addClass('active');
        $(this).find('[type="checkbox"]').attr('checked', 'true');
      }
    });

    $('.set-full-height').css('height', 'auto');

    $(window).resize(() => {
      $('.wizard-produtos').each(function () {
        setTimeout(() => {
          const $wizard = $(this);
          const index = $wizard.bootstrapWizard('currentIndex');
          let $total = $wizard.find('.nav li').length;
          let $li_width = 100 / $total;

          let total_steps = $wizard.find('.nav li').length;
          let move_distance = $wizard.width() / total_steps;
          let index_temp = index;
          let vertical_level = 0;

          let mobile_device = $(document).width() < 600 && $total > 3;
          if (mobile_device) {
            move_distance = $wizard.width() / 2;
            index_temp = index % 2;
            $li_width = 50;
          }

          $wizard.find('.nav li').css('width', $li_width + '%');

          let step_width = move_distance;
          move_distance = move_distance * index_temp;

          let $current = index + 1;

          if ($current == 1 || (mobile_device == true && (index % 2 == 0))) {
            move_distance -= 8;
          } else if ($current == total_steps || (mobile_device == true && (index % 2 == 1))) {
            move_distance += 8;
          }

          if (mobile_device) {
            let x: any = index / 2;
            vertical_level = parseInt(x);
            vertical_level = vertical_level * 38;
          }

          $wizard.find('.moving-tab').css('width', step_width);
          $wizard.find('.moving-tab').css({
            'transform': 'translate3d(' + move_distance + 'px, ' + vertical_level + 'px, 0)',
            'transition': 'all 0.5s cubic-bezier(0.29, 1.42, 0.79, 1)'
          });

          $wizard.find('.moving-tab').css({
            'transition': 'transform 0s'
          });
        }, 500);

      });
    });

  }



  fechar() {
    this.dialogRef.close();
  }

  alterouTab(index) {
    this.ativaAba(Number(this.configuracaoFamiliaOrcamento.familias[index].idFamilia));
    this.selected.setValue(index);
  }

  buscarVerPrecosProdutos() {
    this.carregandoService.mostra('buscarVerPrecosProdutos');
    this.premissasService.consultarVerPrecoProdutos().subscribe(f => {
      this.mostrarValores = f.valor;
      this.carregandoService.esconde('buscarVerPrecosProdutos');
    }, (erro) => {
      this.carregandoService.esconde('buscarVerPrecosProdutos');
      this.notificacaoService.erro(erro);
    });
  }


  protected readonly TipoFiltroProduto = TipoFiltroProduto;
}
